import React, { Component } from 'react'
import { PanelGroup, Panel } from 'react-bootstrap'
import MigrationKeyPanel from './MigrationKeyPanel'

class HostGatorFAQs extends Component{
	constructor(props){
		super(props)
		this.state = {}
		this.handleFAQSelect = this.handleFAQSelect.bind(this)
	}

	handleFAQSelect(activeFAQKey) {
		let _key = this.state.activeFAQKey
		if (_key && _key == activeFAQKey) {
			this.setState({ activeFAQKey: false })
		} else {
			this.setState({ activeFAQKey: activeFAQKey })
		}
	}

	render(){
		const { bvKeyMigrationEnabled } = this.props
		const { activeFAQKey } = this.state
		return (
			<div>
				<PanelGroup
					accordion
					id="hostgator"
					activeKey={activeFAQKey}
					onSelect={this.handleFAQSelect}
					bsClass="col-xs-10 col-md-10 bv-faq-accordion-list"
				>

				<Panel eventKey="1">
					<Panel.Heading bsClass="panel-heading">
						<Panel.Title toggle>
							<p className="bv-faq-que">
								{ this.state.activeFAQKey == "1" ? <i className="mdi mdi-minus"></i> : <i className="mdi mdi-plus"></i> }
								What is Destination Site URL?
							</p>
						</Panel.Title>
					</Panel.Heading>
					<Panel.Body collapsible>
						<p className="bv-faq-ans">
							Destination Site URL of the site you are moving to.
						</p>
					</Panel.Body>
				</Panel>

				<Panel eventKey="2">
					<Panel.Heading bsClass="panel-heading">
						<Panel.Title toggle>
							<p className="bv-faq-que">
								{ this.state.activeFAQKey == "2" ? <i className="mdi mdi-minus"></i> : <i className="mdi mdi-plus"></i> }
								Where can I find my server IP address?
							</p>
						</Panel.Title>
					</Panel.Heading>
					<Panel.Body collapsible>
						<p className="bv-faq-ans">
							To find your domain name and server IP address, log into your cPanel account -> <strong>General Information</strong>.
						</p>
					</Panel.Body>
				</Panel>

				<Panel eventKey="3">
					<Panel.Heading bsClass="panel-heading">
						<Panel.Title toggle>
							<p className="bv-faq-que">
								{ this.state.activeFAQKey == "3" ? <i className="mdi mdi-minus"></i> : <i className="mdi mdi-plus"></i> }
								Where can I find my cPanel Credentials?
							</p>
						</Panel.Title>
					</Panel.Heading>
					<Panel.Body collapsible>
						<p className="bv-faq-ans">
							Your <strong>domain name (destination site URL)</strong>,
							<strong>destination server IP Address</strong> along with your <strong>cPanel username</strong>,
							and <strong>password</strong> are in the <strong>welcome mail</strong> you receive when you register an account with HostGator.
							The subject line of the email may be <strong>HostGator.com :: Your Account Info</strong>.
						</p>
					</Panel.Body>
				</Panel>

					{bvKeyMigrationEnabled ? <MigrationKeyPanel eventKey='4' activeFAQKey={activeFAQKey} /> : null}
			</PanelGroup>
			</div>
		)
	}
}

export default HostGatorFAQs
